import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EDebugLevelSCE } from '../../enums/EDebugLevelSCE';

@Component({
  selector: 'di-choix-level-debug-sce',
  templateUrl: './choix-level-debug-sce.component.html',
  styleUrls: ['./choix-level-debug-sce.component.scss'],
})
export class ChoixLevelDebugSCEComponent implements OnInit {

  ordoDebug: FormGroup;
  debugLevels = [
    { label: "DEBUG", value: EDebugLevelSCE.DEBUG },
    { label: "INFO", value: EDebugLevelSCE.INFO },
    { label: "WARNING", value: EDebugLevelSCE.WARNING },
    { label: "ERROR", value: EDebugLevelSCE.ERROR }
  ];

  constructor(private fb: FormBuilder) {
    this.ordoDebug = this.fb.group({
      debugLevel: [EDebugLevelSCE.WARNING]
    });
  }

  ngOnInit(): void {}

  @Input() onConfirm :Function;
  @Input() onCancel :Function;

  handleOnConfirm() {
    this.onConfirm(this.ordoDebug.get('debugLevel')?.value);
  }

  handleOnCancel() {
    this.onCancel();
  }
}